import { render, staticRenderFns } from "./LinkRow.vue?vue&type=template&id=2508d056"
import script from "./LinkRow.vue?vue&type=script&lang=js"
export * from "./LinkRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports